'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var strings = require('./strings.js');

function daysInMonth(month, year) {
  switch (month) {
    case 2:
      return year % 4 === 0 && year % 100 || year % 400 === 0 ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
    default:
      return 31;
  }
}
const DATE_SEPARATOR = "-";
function isoDate(day, month, year) {
  return [year, strings.leftPad(month), strings.leftPad(day)].join(DATE_SEPARATOR);
}
function fromIsoDate(dateValue) {
  if (!dateValue) {
    return { day: "", month: "", year: "" };
  }
  const splitDate = dateValue.split(DATE_SEPARATOR);
  return {
    day: splitDate[2] || "",
    month: splitDate[1] || "",
    year: splitDate[0] || ""
  };
}
function convertToIsoDate(date) {
  const day = date.getDate().toString();
  const month = (date.getMonth() + 1).toString();
  const year = date.getFullYear().toString();
  return isoDate(day, month, year);
}
function convertToDate(date) {
  if (typeof date === "string" || typeof date === "number") {
    return new Date(date);
  }
  return date;
}
function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime());
}
function duration(time) {
  const days = Math.floor(time / exports.TimeValue.DAY);
  time = time % exports.TimeValue.DAY;
  const hours = Math.floor(time / exports.TimeValue.HOUR);
  time = time % exports.TimeValue.HOUR;
  const minutes = Math.floor(time / exports.TimeValue.MINUTE);
  time = time % exports.TimeValue.MINUTE;
  const seconds = Math.floor(time / exports.TimeValue.SECOND);
  return { days, hours, minutes, seconds };
}
const zeroPad = (value, totalDigitCount = 2) => String(value).padStart(totalDigitCount, "0");
(function(TimeValue2) {
  TimeValue2[TimeValue2["DAY"] = 864e5] = "DAY";
  TimeValue2[TimeValue2["HOUR"] = 36e5] = "HOUR";
  TimeValue2[TimeValue2["MINUTE"] = 6e4] = "MINUTE";
  TimeValue2[TimeValue2["SECOND"] = 1e3] = "SECOND";
})(exports.TimeValue || (exports.TimeValue = {}));
function convertToLocalDate(date) {
  return new Date(date.getTime() + date.getTimezoneOffset() * 6e4);
}
function isBetween(date, from, to) {
  return date >= from && date <= to;
}
function isToday(date) {
  return date.toDateString() === new Date().toDateString();
}
const isDaysApart = (date, days) => {
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + days);
  return futureDate.getFullYear() === date.getFullYear() && futureDate.getMonth() === date.getMonth() && futureDate.getDate() === date.getDate();
};
const isTomorrow = (date) => isDaysApart(date, 1);
const isYesterday = (date) => isDaysApart(date, -1);

exports.convertToDate = convertToDate;
exports.convertToIsoDate = convertToIsoDate;
exports.convertToLocalDate = convertToLocalDate;
exports.daysInMonth = daysInMonth;
exports.duration = duration;
exports.fromIsoDate = fromIsoDate;
exports.isBetween = isBetween;
exports.isDaysApart = isDaysApart;
exports.isToday = isToday;
exports.isTomorrow = isTomorrow;
exports.isValidDate = isValidDate;
exports.isYesterday = isYesterday;
exports.isoDate = isoDate;
exports.zeroPad = zeroPad;
